import { Container, Stack } from 'react-bootstrap';

export function Footer() {
  return (
    <footer
      style={{
        position: 'fixed',
        bottom: 0,
        width: '100%',
        padding: 'clamp(16px, 3vw, 22px) 0',
        background: 'linear-gradient(180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.03) 100%)',
        zIndex: 100,
      }}
    >
      <BootstrapFooterContent />
    </footer>
  );
}
function BootstrapFooterContent() {
  return (
    <Container style={{ maxWidth: 1200, padding: '0 clamp(8px, 2vw, 16px)' }} >
      <Stack direction="horizontal" className="justify-content-center">
        <div
          className="footer-badge"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 999,
            background: 'var(--theme-surface, #f8f9fa)',
            border: '1px solid var(--theme-border, #dee2e6)',
            color: 'var(--theme-textSecondary, #6c757d)',
            lineHeight: 1.2,
            boxShadow: '0 6px 18px rgba(0,0,0,0.08)',
            maxWidth: '100%',
            minWidth: 'fit-content',
          }}
        >
          <span 
            style={{ 
              color: 'var(--theme-text)', 
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              lineHeight: 1.2,
            }}
          >
            Powered by
          </span>
          <a
            href="https://tokentiger.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: 'var(--theme-primary, #007bff)',
              fontWeight: 700,
              textDecoration: 'none',
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              lineHeight: 1.2,
            }}
          >
            TokenTiger™
          </a>
        </div>
      </Stack>
    </Container>
  );
}

